module.exports = __webpack_public_path__ + "static/img/8.0ef72d5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/6/eng/8.png
// module id = oGsJ
// module chunks = 0